import { FC } from "react";
import { WithChildren } from "apps/website/types";

import { IconSvg } from "../../base/Icon/Icon.map";
import Icon from "../../base/Icon/Icon";
import TextSubtitle from "../../base/Text/TextSubtitle/TextSubtitle";

export interface IConfirmationBarProps extends WithChildren {
  icon: IconSvg
}
export const ConfirmationBar: FC<IConfirmationBarProps> = ({ icon, children }) => (
  <div data-component={ConfirmationBar.name} className="w-full p-2 bg-mid-green flex justify-center items-center">
    <div className="w-6 h-6 lg:w-8 lg:h-8">
      <Icon icon={icon} size="fit"/>
    </div>
    <TextSubtitle size={3} align="center" data-testid="ConfirmationBar-title">{ children }</TextSubtitle>
  </div>
);
